import PropTypes from 'prop-types';
import _isArray from 'lodash/isArray';

import styles from './documents-modal.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import ModalBasic from '../../../atoms/modal-basic';
import TableBasic from '../../../atoms/table-basic';
import parse from 'html-react-parser';

const className = augmentClassName(styles);

const getParagraphContent = modalContent => {
  if (_isArray(modalContent)) {
    return modalContent.map((paragraph, index) => {
      return (
        <div
          data-key={`${(paragraph || '').slice(0, 32)}-${index}`}
          key={`${(paragraph || '').slice(0, 32)}-${index}`}
          {...className('paragraph')}
        >
          <p>{paragraph}</p>
        </div>
      );
    });
  }
  return <div {...className('paragraph')}>{parse(modalContent)}</div>;
};

const DocumentsModal = ({ onHide, show, modalTitle, modalContent }) => {
  const isFactSheets = modalTitle === 'Fact Sheets';

  return (
    <ModalBasic show={show} onHide={onHide}>
      <ModalBasic.Header>
        <ModalBasic.Title>
          <ModalBasic.Subtitle>
            <div {...className('title')}>{modalTitle}</div>
          </ModalBasic.Subtitle>
        </ModalBasic.Title>
        <ModalBasic.CloseButton onClick={onHide} />
      </ModalBasic.Header>
      <ModalBasic.Body>
        {isFactSheets ? (
          <TableBasic>
            <tbody>
              {modalContent.map((value, index) => {
                return (
                  <tr
                    data-key={`${value.planName || ''}-${index}`}
                    key={`${value.planName || ''}-${index}`}
                  >
                    <td>
                      <a href={value.url} target="_blank" rel="noopener noreferrer">
                        {value.planName}
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </TableBasic>
        ) : (
          getParagraphContent(modalContent)
        )}
      </ModalBasic.Body>
    </ModalBasic>
  );
};

DocumentsModal.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool,
  modalTitle: PropTypes.string,
  modalContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default DocumentsModal;
